export const BASE_URL = process.env.REACT_APP_API_URL;
export const API_KEY = process.env.X_API_KEY;
export const TOKEN = "0xf29d48b47e51441837B45c9437A7E9A224b28Da4";
export const AIRDROP_CONTRACT_ADDRESS = "0xfC7B0d3BF5Ee8eEfd4fd8688cc244e8d0d964B9a";
export const STANDARD_IMAGE_URL = "https://wow-dash.com/demo/assets/images/user-grid/user-grid-bg1.png";

export const AIRDROP_STATUS = Object.freeze({
     PENDING: "pending",
     SUCCESS: "success",
     FAILED: "failed",
});        
